import React from 'react';

const Spotify = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <path
      fill="currentColor"
      d="M28.69 16.62c-5.753-3.415-15.24-3.73-20.732-2.063a1.668 1.668 0 1 1-.969-3.194C13.293 9.45 23.771 9.82 30.393 13.75a1.669 1.669 0 0 1-1.704 2.87m-.188 5.06c-.404.655-1.26.86-1.914.459-4.795-2.948-12.108-3.802-17.781-2.08a1.393 1.393 0 0 1-1.736-.927 1.393 1.393 0 0 1 .927-1.735c6.481-1.967 14.538-1.014 20.046 2.37.654.403.86 1.26.458 1.913Zm-2.184 4.86a1.112 1.112 0 0 1-1.529.37c-4.19-2.562-9.465-3.14-15.676-1.721a1.11 1.11 0 1 1-.495-2.168c6.797-1.554 12.628-.885 17.331 1.989a1.112 1.112 0 0 1 .37 1.53M18.134.8C8.279.801.289 8.791.289 18.646c0 9.856 7.99 17.844 17.845 17.844 9.855 0 17.844-7.988 17.844-17.844C35.978 8.79 27.99.8 18.134.8"
    />
  </svg>
);

export default Spotify;
